import PBXCalls from "./PBXCalls";

const PBXCallsConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/callcenter/dialer',
			component: PBXCalls
		}
	]
};

export default PBXCallsConfig;
